import { render, staticRenderFns } from "./agentWechatRefund.vue?vue&type=template&id=8ec13a62&"
import script from "./agentWechatRefund.vue?vue&type=script&lang=js&"
export * from "./agentWechatRefund.vue?vue&type=script&lang=js&"
import style0 from "./agentWechatRefund.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports